import { combineReducers } from 'redux';
import contentReducer from './ContentReducer';
import appStateReducer from './AppStateReducer';
import tenantReducer from './TenantReducer';
import appUpdateReducer from './AppUpdateReducer';
import profileReducer from './ProfileReducer';
import cartReducer from './CartReducer';
import orderServReducer from './OrderServReducer';
import marketConfigReducer from './MarketConfigReducer';
import moreReducer from './MoreReducer';
import orderLookUpReducer from './OrderLookUpReducer';
import placesAutocompleteReducer from './PlacesAutocompleteReducer';
import storesReducer from './StoresReducer';
import { menuReducer } from './MenuReducer';
import specialEventReducer from './SpecialEventReducer';
import helpReducer from './HelpReducer';
import i18nReducer from './I18nReducer';
import paymentsReducer from './PaymentsReducer';
import authReducer from './AuthReducer';
import orderReducer from './OrderReducer';
import paymentsContentReducer from './PaymentsContentReducer';
import privacyPolicyReducer from './PrivacyPolicyReducer';
import ourAdsReducer from './OurAdsReducer';
import analyticsReducer from './AnalyticsReducer';
import appRatingsReducer from './AppRatingsReducer';
import appConfigsReducer from './AppConfigsReducer';
import brandPageReducer from './BrandPageReducer';
import LoaderReducer from './LoaderReducer';
import postOrderReducer from './PostOrderReducer';
import deliveryAggregatorReducer from './DeliveryAggregatorReducer';
import ourFaqReducer from './FaqReducer';
import paymentsGiftCardReducer from './PaymentsGiftCardReducer';
import paymentsGoogleSpotReducer from './PaymentsGoogleSpotReducer';
import createBalanceReducer from './GiftCheckBalanceReducer';
import contactUsReducer from './ContactUsReducer';
import termsOfUseReducer from './TermsOfUseReducer';
import feedbackReducer from './FeedbackReducer';
import giftCardReducer from './GiftCardReducer';
import SecretMenuReducer from './SecretMenuReducer';
import giftCardPurchaseReducer from './GiftCardPurchaseReducer';
import orderHistoryReducer from './OrderHistoryReducer';
import errorReducer from './ErrorReducer';
import splashLoaderReducer from './SplashLoaderReducer';
import microAppPaymentReducer from './MicroAppPaymentReducer';
import { CLEAR_REDUX_STORE } from '../../constants';
import reorderReducer from './ReorderReducer';
import appVersionReducer from './AppVersionReducer';
import PlpDisclaimerReducerContent from './PlpDisclaimerReducer';
import braintreePaymentReducer from './BraintreePaymentReducer';
import protectedDisclosureReducer from './ProtectedDisclosureReducer';
import nutritionAllergenDisclaimerReducer from './NutritionAllergenDisclaimerReducer';
import contentfulReducer from '../Slices/ContentfulSlice';
import brazeSubscriptionReducer from '../Slices/BrazeSubscriptionSlice';
import brazeSubscriptionReducerV2 from '../Slices/BrazeSubscriptionSliceV2';
import naSingleItemReducer from './NASingleItemReducer';
import pwaStoragsReducer from '../Slices/PwaStorageSlice';
export const appReducer = combineReducers({
    contentReducer,
    appStateReducer,
    tenantReducer,
    appUpdateReducer,
    profileReducer,
    cartReducer,
    orderServReducer,
    marketConfigReducer,
    moreReducer,
    placesAutocompleteReducer,
    storesReducer,
    orderLookUpReducer,
    menuReducer,
    specialEventReducer,
    helpReducer,
    paymentsReducer,
    authReducer,
    i18nReducer,
    orderReducer,
    paymentsContentReducer,
    paymentsGiftCardReducer,
    paymentsGoogleSpotReducer,
    createBalanceReducer,
    privacyPolicyReducer,
    ourAdsReducer,
    appRatingsReducer,
    appConfigsReducer,
    brandPageReducer,
    LoaderReducer,
    postOrderReducer,
    deliveryAggregatorReducer,
    ourFaqReducer,
    contactUsReducer,
    termsOfUseReducer,
    SecretMenuReducer,
    feedbackReducer,
    giftCardReducer,
    giftCardPurchaseReducer,
    orderHistoryReducer,
    errorReducer,
    splashLoaderReducer,
    microAppPaymentReducer,
    reorderReducer,
    appVersionReducer,
    PlpDisclaimerReducerContent,
    analyticsReducer,
    braintreePaymentReducer,
    protectedDisclosureReducer,
    nutritionAllergenDisclaimerReducer,
    contentfulReducer,
    brazeSubscriptionReducer,
    brazeSubscriptionReducerV2,
    naSingleItemReducer,
    pwaStoragsReducer,
});
export const rootReducer = (state, action) => {
    if (action.type === CLEAR_REDUX_STORE) {
        state = undefined;
    }
    return appReducer(state, action);
};
